import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import styles from './LexusStartService.module.css';
import useLineLiff from 'hooks/LineLiff';
import { activeRichMenu } from './utils/LineLoginActions';

const LexusStartServicePage = () => {
  const [registered, setRegistered] = useState(false);
  const [searchParams] = useSearchParams();

  const { liff, userInfo, errorMsg, setErrorMsg } = useLineLiff(
    process.env.REACT_APP_LIFF_ID_START
  );

  useEffect(() => {
    if (!userInfo) return;
    const idToken = liff.getIDToken();

    const activeRichMenuToService = async () => {
      try {
        const paramsLocation = searchParams.getAll('location');
        const result = await activeRichMenu(
          idToken,
          paramsLocation ? { location: paramsLocation } : {}
        );
        if (!result.success) {
          setErrorMsg(result.message);
        } else {
          setRegistered(true);
          // liff.closeWindow();
          window.location.href = process.env.REACT_APP_LEXUS_LINE_URL;
        }
      } catch (err) {
        setErrorMsg(
          `error occurred while fetching user details: ${err.message}`
        );
      }
    };

    activeRichMenuToService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  return (
    <div className={styles.container}>
      {registered ? (
        <div className={styles.text}>服務啟用成功</div>
      ) : (
        <div className={styles.row}>
          <div className={styles.spinner} style={{ marginRight: '8px' }}></div>
          <p>服務啟用中...</p>
        </div>
      )}
      {errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}
    </div>
  );
};

export default LexusStartServicePage;
